import { FC } from 'react';
import { Text } from '@bpba/ui-components';

type Props = {
  show: boolean | undefined;
  id: string;
  otpLength: number;
};

export const OtpError: FC<Props> = ({ show, id, otpLength }) => {
  const errorMessage = `Este campo debe contener ${otpLength} números.`;
  const ariaLabel = show ? errorMessage : '';
  const text = show ? `*${errorMessage}` : '&nbsp;';

  return <Text color="red" fontSize={'10px'} lineHeight="16px" margin="0" id={id} aria-label={ariaLabel} dangerouslySetInnerHTML={{ __html: text }} />;
};
